/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1ExamLangsIdMutationRequest,
  PutApiV1ExamLangsIdMutationResponse,
  PutApiV1ExamLangsIdPathParams,
  PutApiV1ExamLangsId401,
  PutApiV1ExamLangsId404,
  PutApiV1ExamLangsId500,
} from "../../types/examEvaluationController/PutApiV1ExamLangsId.ts";

function getPutApiV1ExamLangsIdUrl(id: PutApiV1ExamLangsIdPathParams["id"]) {
  const res = { method: "PUT", url: `/api/v1/exam/langs/${id}` as const };
  return res;
}

/**
 * @description Atualiza os dados de um idioma de prova existente. O CultureInfo deve ser único por prova. **(Requer Authorization para autenticação)**
 * @summary Atualizar idioma de prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/langs/:id}
 */
export async function putApiV1ExamLangsId(
  id: PutApiV1ExamLangsIdPathParams["id"],
  data?: PutApiV1ExamLangsIdMutationRequest,
  config: Partial<RequestConfig<PutApiV1ExamLangsIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1ExamLangsIdMutationResponse,
    ResponseErrorConfig<
      PutApiV1ExamLangsId401 | PutApiV1ExamLangsId404 | PutApiV1ExamLangsId500
    >,
    PutApiV1ExamLangsIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1ExamLangsIdUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
